module.exports = __webpack_public_path__ + "static/media/food-chain-asparagus-pickers-desktop.e3373b4c.jpg";